export const setCuisines = (cuisines) => ({
    type: 'SET_CUISINES',
    cuisines
});